export const inputServices = services => (Array.isArray(services) ? services : []).filter(
  service => (service.calculation_type || service.additional_service?.calculation_type) === 'per_input'
);

export function currentServiceInputs(services, values = {}, previous = {}) {
  return Object.fromEntries(inputServices(services).map(service => [String(service.id),
    values?.[service.id] ?? previous?.[service.id] ?? service.input_value ?? ''
  ]));
}

export function invalidInputServices(services, values) {
  return inputServices(services).filter(service => {
    const value = values[String(service.id)];
    const number = Number(value);
    return value === '' || value === null || typeof value === 'boolean' || !Number.isFinite(number) || number <= 0 || number > 10000000;
  });
}

export function serviceInputSignature(services) {
  return JSON.stringify(inputServices(services).map(service => [String(service.id),
    service.input_label || service.additional_service?.input_label || service.custom_title || '',
    service.input_unit || service.additional_service?.input_unit || '', String(service.input_value ?? '')
  ]).sort((a, b) => a[0].localeCompare(b[0])));
}
